<template>
  <div>
    <ShowFilter />
    <div class="show-list loader-container">
      <ShowTile v-for="show in shows" :key="show.id" :show="show" />
      <Loader :loading="loading" />
      <div v-if="shows.length == 0 && !loading">No Results Found</div>
      <div v-if="moreAvailable && !loading">
        <button class="ui-button" type="button" @click.prevent="loadMore()">Load More</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ShowTile from '@/components/ShowTile';
import Loader from '@/components/Loader';
import ShowFilter from '@/components/ShowFilter';
import Service from '@/services/Service.js';

export default {
  components: {
    ShowTile,
    Loader,
    ShowFilter
  },
  data() {
    return {
      shows: [],
      loading: false,
      page: 1,
      pageSize: 6,
      moreAvailable: false
    };
  },
  computed: mapState(['showFilter']),
  watch: {
    showFilter() {
      //reset the page size when the filter changes
      this.reset();
      this.getShows();
    }
  },
  created() {
    this.getShows();
  },
  methods: {
    getShows() {
      var self = this;
      self.loading = true;
      Service.getShows(this.showFilter, this.page, this.pageSize)
        .then(response => {
          self.shows.push.apply(this.shows, response.data);
          self.moreAvailable =
            response.headers['x-total-count'] > self.pageSize * self.page;
          self.loading = false;
        })
        .catch(() => {
          self.loading = false;
        });
    },
    loadMore: function() {
      this.page += 1;
      this.getShows();
    },
    reset: function() {
      this.page = 1;
      this.shows = [];
    }
  }
};
</script>
